/* Nordicsheep antal-trappe (v2.2, 2026-10-06) — KUMULATIV: man beholder alle optjente fordele.
   2+ varer = gratis fragt (Shopify Automatic, styres ikke her)
   3+ varer = + gratis boerste (NCL1308, variant 49135005499720)
   4+ varer = + gratis toerrebolde (NCL5231, variant 49104052519240)
   5+ varer = + 10% ordre-rabat (Shopify Automatic, styres ikke her)
   Trappen taeller RIGTIGE varer: gave-/tilbehoersvarianterne taeller aldrig med.
   v2.2: saedehynder taeller ALTID med (6-for-5-rabatten er slaaet fra 06-10-2026).
   v2.1: busy-koe (again) saa en reconcile udloest MENS en anden koerer ikke tabes - ellers udeblev gave nr. 2 ved hurtige antal-klik. */
(function () {
  var GIFTS = [
    { min: 3, variant: 49135005499720 },
    { min: 4, variant: 49104052519240 }
  ];
  var EXCLUDED_VARIANTS = [49135005499720, 49104052519240, 50364822978888];
  var PROP = '_free_gift';
  var busy = false;
  var again = false;

  function cartState(cart) {
    var giftLines = [], nonGiftQty = 0, variantPresent = {};
    (cart.items || []).forEach(function (it) {
      variantPresent[it.variant_id] = true;
      if (it.properties && it.properties[PROP]) { giftLines.push(it); return; }
      if (EXCLUDED_VARIANTS.indexOf(it.variant_id) !== -1) return;
      nonGiftQty += it.quantity;
    });
    return { giftLines: giftLines, nonGiftQty: nonGiftQty, variantPresent: variantPresent };
  }

  function getMap(key) {
    try {
      var m = JSON.parse(sessionStorage.getItem(key) || '{}');
      return (m && typeof m === 'object') ? m : {};
    } catch (e) { return {}; }
  }
  function setMap(key, m) {
    try { sessionStorage.setItem(key, JSON.stringify(m)); } catch (e) {}
  }

  function refreshUI(sectionsJson) {
    try {
      if (window.general && general.template === 'cart') { window.location.reload(); return; }
      var aside = document.getElementById('cart');
      if (aside && window.ajaxCart && ajaxCart.load) {
        var open = aside.getAttribute('aria-hidden') === 'false';
        if (sectionsJson && sectionsJson.sections && sectionsJson.sections['side-cart']) {
          ajaxCart.load(sectionsJson, open);
        } else {
          aside.innerHTML = '';
          ajaxCart.load(false, open, false, true);
        }
      }
    } catch (e) { console.log('ns-gift refreshUI', e); }
  }

  function mutate(url, payload) {
    return fetch(url + '?ns_gift=1', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function finish() {
    busy = false;
    if (again) { again = false; setTimeout(reconcile, 120); }
  }

  function reconcile() {
    if (busy) { again = true; return; }
    busy = true;
    fetch('/cart.js?ns_gift=1').then(function (r) { return r.json(); }).then(function (cart) {
      var st = cartState(cart);
      var added = getMap('nsGiftAdded');
      var dismissed = getMap('nsGiftDismissed');

      GIFTS.forEach(function (g) {
        var k = String(g.variant);
        var earned = st.nonGiftQty >= g.min;
        if (!earned) { delete dismissed[k]; delete added[k]; return; }
        if (added[k] && !st.variantPresent[g.variant]) dismissed[k] = 1;
      });

      var ops = [];
      st.giftLines.forEach(function (gl) {
        var gift = null;
        for (var i = 0; i < GIFTS.length; i++) { if (GIFTS[i].variant === gl.variant_id) gift = GIFTS[i]; }
        if (!gift || st.nonGiftQty < gift.min) ops.push({ id: gl.key, quantity: 0 });
        else if (gl.quantity > 1) ops.push({ id: gl.key, quantity: 1 });
      });

      var adds = [];
      GIFTS.forEach(function (g) {
        var k = String(g.variant);
        if (st.nonGiftQty >= g.min && !st.variantPresent[g.variant] && !dismissed[k]) adds.push(g);
      });

      var chain = Promise.resolve(null);
      ops.forEach(function (op) {
        chain = chain.then(function () { return mutate('/cart/change.js', { id: op.id, quantity: op.quantity }); });
      });
      adds.forEach(function (g) {
        chain = chain.then(function () {
          var props = {}; props[PROP] = '1';
          return mutate('/cart/add.js', { id: g.variant, quantity: 1, properties: props, sections: 'side-cart' }).then(function (json) {
            if (json) added[String(g.variant)] = 1;
            return json;
          });
        });
      });
      if (!adds.length && ops.length) {
        chain = chain.then(function () { return mutate('/cart/update.js', { sections: 'side-cart' }); });
      }

      chain.then(function (json) {
        setMap('nsGiftAdded', added);
        setMap('nsGiftDismissed', dismissed);
        if (ops.length || adds.length) refreshUI(json);
        finish();
      }).catch(function () { finish(); });
    }).catch(function () { finish(); });
  }

  var CART_MUTATION = /\/cart\/(add|change|update|clear)/;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    try {
      if (CART_MUTATION.test(url) && url.indexOf('ns_gift=1') === -1) {
        p.then(function () { setTimeout(reconcile, 150); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__nsGiftUrl = url;
    return origOpen.apply(this, arguments);
  };
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    try {
      var u = this.__nsGiftUrl || '';
      if (CART_MUTATION.test(u) && u.indexOf('ns_gift=1') === -1) {
        this.addEventListener('load', function () { setTimeout(reconcile, 150); });
      }
    } catch (e) {}
    return origSend.apply(this, arguments);
  };

  /* Quick-add knapper (.ns-quickadd med data-variant) fra ns-gift-promo: virker globalt, ogsaa i AJAX-injectet drawer-HTML */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ns-quickadd') : null;
    if (!b) return;
    e.preventDefault();
    var v = parseInt(b.getAttribute('data-variant') || '', 10);
    if (!v) return;
    if (b.classList.contains('ns-qa-busy')) return;
    b.classList.add('ns-qa-busy');
    mutate('/cart/add.js', { id: v, quantity: 1, sections: 'side-cart' }).then(function (json) {
      b.classList.remove('ns-qa-busy');
      if (json) { refreshUI(json); setTimeout(reconcile, 200); }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(reconcile, 300); });
  } else {
    setTimeout(reconcile, 300);
  }
})();
